import { api } from "@/api/axios";

export interface PlatformInvitation {
  id: string;

  church_id: string;
  church_name: string;
  church_slug: string;

  invited_email: string;
  invited_first_name?: string | null;
  invited_last_name?: string | null;

  role_code: string;
  invitation_type: string;
  invitation_version: number;

  status: string;
  send_count: number;

  sent_at?: string | null;
  last_sent_at?: string | null;
  expires_at: string;

  accepted_at?: string | null;
  revoked_at?: string | null;
  revocation_reason?: string | null;

  created_at: string;
  updated_at: string;
}

export interface PlatformInvitationListResponse {
  items: PlatformInvitation[];
  total: number;
  offset: number;
  limit: number;
}

export interface GetPlatformInvitationsParams {
  search?: string;
  status?: string;
  churchId?: string;
  offset?: number;
  limit?: number;
}

export async function getPlatformInvitations(
  params: GetPlatformInvitationsParams = {},
) {
  const response =
    await api.get<PlatformInvitationListResponse>(
      "/api/platform/invitations",
      {
        params: {
          search: params.search || undefined,
          status: params.status || undefined,
          church_id: params.churchId || undefined,
          offset: params.offset ?? 0,
          limit: params.limit ?? 50,
        },
      },
    );

  return response.data;
}
export interface ResendPlatformInvitationRequest {
  expires_in_days: number;
}

export interface UpdatePlatformInvitationEmailRequest {
  invited_email: string;
  invited_first_name?: string | null;
  invited_last_name?: string | null;
  expires_in_days: number;
}

export interface InvitationManagementResponse {
  message: string;
  invitation: PlatformInvitation;
  invitation_token?: string | null;
}

export async function resendPlatformInvitation(
  churchId: string,
  request: ResendPlatformInvitationRequest,
) {
  const response =
    await api.post<InvitationManagementResponse>(
      `/api/platform/churches/${churchId}/invitation/resend`,
      request,
    );

  return response.data;
}

export async function updatePlatformInvitationEmail(
  churchId: string,
  request: UpdatePlatformInvitationEmailRequest,
) {
  const response =
    await api.patch<InvitationManagementResponse>(
      `/api/platform/churches/${churchId}/invitation/email`,
      request,
    );

  return response.data;
}

export async function revokePlatformInvitation(
  churchId: string,
  reason = "Revoked by Platform Administrator",
) {
  const response = await api.post<InvitationManagementResponse>(
    `/api/platform/churches/${churchId}/invitation/revoke`,
    { reason },
  );
  return response.data;
}

